import { Mic, Square } from 'lucide-react';
import { MAX_RECORD_SECONDS } from '@/hooks/useRecorder';

const fmt = (s) => `0:${String(s).padStart(2, '0')}`;

export const RecordButton = ({ isRecording, seconds, disabled, disabledReason, onToggle, compact = false }) => (
  <div className={`flex flex-col items-center ${compact ? 'gap-0.5' : 'gap-2'}`}>
    <button
      onClick={onToggle}
      disabled={disabled}
      data-testid="record-button"
      aria-label={isRecording ? 'Detener grabación' : 'Grabar'}
      className={`rounded-full flex items-center justify-center shadow-lg active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed
        ${compact ? 'h-14 w-14' : 'h-24 w-24'}
        ${isRecording ? 'bg-destructive text-destructive-foreground animate-pulse-ring' : 'bg-primary text-primary-foreground'}`}
    >
      {isRecording
        ? <Square className={`fill-current ${compact ? 'h-5 w-5' : 'h-9 w-9'}`} />
        : <Mic className={compact ? 'h-6 w-6' : 'h-10 w-10'} />}
    </button>
    <p className={`font-semibold text-foreground ${compact ? 'text-xs' : 'text-base'}`} data-testid="record-button-label">
      {isRecording ? `Detener · ${fmt(seconds)} / ${fmt(MAX_RECORD_SECONDS)}` : 'Grabar'}
    </p>
    {disabled && disabledReason && !compact && (
      <p className="text-sm text-muted-foreground text-center" data-testid="record-disabled-reason">{disabledReason}</p>
    )}
  </div>
);
